import { useParams, useSearchParams } from "react-router-dom";

const useLocalSampleSummaryParams = () => {
  const { hash, sourceId } = useParams();
  const [searchParams] = useSearchParams();

  const relationshipIdParam = searchParams.get("r") ?? "0";
  const parentHashParam = searchParams.get("p");
  const droppedSourceIdParam = searchParams.get("dropped_source_id");
  const auxiliarySourceIdParam = searchParams.get("auxiliary_source_id");

  const relationshipIdParsed = parseInt(relationshipIdParam, 10);

  const droppedSourceIdParsed = droppedSourceIdParam || undefined;

  const auxiliarySourceIdParsed = auxiliarySourceIdParam || undefined;

  const sourceIdParsed = sourceId ? parseInt(sourceId, 10) : undefined;

  const parentHashParsed =
    parentHashParam == null ? undefined : parentHashParam;

  return {
    hash,
    sourceId: sourceIdParsed,
    relationshipId: relationshipIdParsed,
    parentHash: parentHashParsed,
    droppedSourceId: droppedSourceIdParsed,
    auxiliarySourceId: auxiliarySourceIdParsed
  };
};

export default useLocalSampleSummaryParams;
